import {
  ActivityTrackerEventType,
  ShopRearrangeMethods,
} from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useShopTracking() {
  const [, user] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({ userId: user?.id });

  return {
    sendRearrangeShopEvent() {
      sendActivityTrackerEvent(ActivityTrackerEventType.SHOP_REARRANGE_ACTION, {
        method: ShopRearrangeMethods.Rearrange,
        schemaVersion: '1.0',
      });
    },
  };
}
